import { render, staticRenderFns } from "./AdminServiceAreaCategoryList.vue?vue&type=template&id=bf4c06ee"
import script from "./AdminServiceAreaCategoryList.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports